module.exports = __webpack_public_path__ + "img/schulungen.2a2cc6c5.svg";